import { HostListener, Directive } from '@angular/core';
import { Compbaser } from './compbases';
import {MatDialog} from "@angular/material/dialog";
import * as _ from "lodash";

@Directive()
/** Compbaser for property panel with slide animation */
// tslint:disable-next-line
export class SpecialCompbaser extends Compbaser {

    toggleWidth = 780;
    sidenavMode;
    sidenavOpened = true;
    m_togglePropsPanel;

    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        this.m_togglePropsPanel();
    }

    constructor(protected override dialog?: MatDialog) {
        super(dialog);
        this.toggleSlideOnResize();
        this.m_togglePropsPanel = _.debounce(() => {
            this.toggleSlideOnResize();
        }, 100);
    }

    protected toggleSlideOnResize() {
        if (window.innerWidth < this.toggleWidth) {
            this.sidenavMode = 'over';
            this.sidenavOpened = false;
        } else {
            this.sidenavMode = 'side';
            this.sidenavOpened = true;
        }
    }

    protected toggleSlide(width) {
        if (width < this.toggleWidth) {
            this.sidenavMode = 'over';
        } else {
            this.sidenavMode = 'side';
        }
    }


}
